<template>
  <div class="template-form">
    <el-form
      :model="value"
      :rules="rules"
      ref="ruleForm"
      :label-width="labelWidth"
      class="form-content"
    >
      <el-form-item label="上传项目" prop="projectId" v-show="showProject">
        <span>{{ projectName }}</span>
        <span class="proj-tip"
          ><i class="el-icon-warning"></i>如需修改请在顶部切换项目</span
        >
      </el-form-item>
      <el-form-item label="模板名称" prop="name">
        <el-input
          v-model="value.name"
          placeholder="模板名称"
          max="20"
          class="input-w"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isAdminPucTpl" label="模板类目(选填)" class="tf-tag">
        <self-select
          class="input-w"
          v-model="value.categoryIds"
          :canAdd="false"
        >
          <self-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </self-option>
        </self-select>
      </el-form-item>
      <el-form-item v-else label="模板分类(选填)" prop="tagNames" class="tf-tag">
        <self-select
          placeholder="支持自定义多个标签,点击Enter键完成标签输入"
          class="input-w"
          :isFlex="false"
          v-model="value.tagNames"
          ref="select"
          placement="bottom"
        >
          <self-option key="-1" label="" value="" @onClick="onCreateClick">
            <div slot="header">新建分类</div>
          </self-option>
          <self-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </self-option>
        </self-select>
      </el-form-item>
      <el-form-item
        label="模板标签(选填)"
        prop="tagNames"
        class="tf-tag"
        v-if="$store.getters['app/isSYSAdmin']"
      >
        <el-input
          v-model="value.label"
          placeholder="自定义标签"
          max="20"
          class="input-w"
        ></el-input>
      </el-form-item>
      <el-form-item prop="tplGroupName" class="tf-group">
        <label slot="label"
          >{{ shortName }}
          <el-tooltip
            :visible-arrow="false"
            popper-class="c-warn-msg group-warn-tip"
            effect="light"
            :content="`一个“${shortName}”，支持页面同时导出`"
            placement="top"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </label>
        <el-autocomplete
          style="width: 100%"
          class="input-w"
          v-model="value.tplGroupName"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="可商用" prop="canCommercial">
        <el-checkbox v-model="value.canCommercial" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { empty_template } from '@/const.js'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default () {
        return JSON.parse(JSON.stringify(empty_template))
      }
    },
    showProject: {
      type: Boolean,
      default: true
    },
    shortName: {
      type: String,
      default: '联动组(选填)'
    },
    shortNameRequire: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '80px'
    }
  },
  data () {
    return {
      saveLoading: false,
      rules: {
        projectId: [
          { required: true, message: '项目不能为空', trigger: 'change' }
        ],
        name: [{ required: true, message: '名称不能为空', trigger: 'change' }],
        tplGroupName: [
          {
            required: this.shortNameRequire,
            message: '分组不能为空',
            trigger: 'change'
          }
        ],
        json: [
          { required: true, message: 'psd数据不能为空', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      pubCategoryList: 'app/categoryList'
    }),
    projects () {
      return this.$store.state.app.loginUser.projectItems
    },
    projectId () {
      return this.isAdminPucTpl ? this.$store.state.app.loginUser.publicProject.id : this.$store.state.app.projectId
    },
    projectName () {
      let idx = this.projects.findIndex(item => {
        return item.id === this.projectId
      })
      if (idx > -1) {
        return this.projects[idx].name
      } else {
        return ''
      }
    },
    options () {
      return this.isAdminPucTpl ? this.pubCategoryList: this.formatterTemplateTags(this.$store.state.app.templateTags)
    },
    groupArray () {
      return this.$store.state.app.templateGroups
    },
    isAdminPucTpl () {
      return this.$route.name === 'admin-template-public'
    }
  },
  // watch: {
  //   'value.categoryIds': {
  //     deep: true,
  //     handler (val) {
  //       console.log('value', val, this.value)
  //     }
  //   }
  // },
  methods: {
    formatterTemplateTags (data) {
      let names = []
      data.forEach(item => {
        names.push({
          value: item.name,
          label: item.name
        })
      })
      return names
    },
    _resetForm () {
      this.$refs['ruleForm'].resetFields()
    },
    _validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            if (!this.value.json.width) {
              this.$message.error('psd文件宽度为0')
              reject('psd文件宽度为0')
            }
            if (!this.value.defaultUrl) {
              this.$message.error('psd base64值为空')
              reject('psd base64值为空')
            }
            resolve('success')
          } else {
            this.$message.error('请填写正确的表单信息')
            reject('请填写正确的表单信息')
          }
        })
      })
    },
    querySearch (queryString, cb) {
      var groupArray = this.groupArray
      if (queryString && groupArray.length > 0) {
        queryString = queryString.toLocaleString()
        let result = groupArray.filter(item => {
          return item.value.toLowerCase().indexOf(queryString) === 0
        })
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          cb(result)
        }, 500)
      } else {
        cb(groupArray)
      }
    },
    onCreateClick () {
      this.$refs.select.togglePopover(false)
    }
  }
}
</script>
<style lang="scss">
@import './template-form';
</style>
